import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-643af6c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dk-navbar__nav-item" }
const _hoisted_2 = ["aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DKIcon = _resolveComponent("DKIcon")!
  const _component_MegamenuLocationOverview = _resolveComponent("MegamenuLocationOverview")!
  const _component_Megamenu = _resolveComponent("Megamenu")!

  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    (_ctx.isDesktop)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: _normalizeClass(["dk-navbar__nav-item-link", {
        'dk-navbar__nav-item-link--expanded': _ctx.isExpanded,
      }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('clickLocationSwitcher'))),
          "aria-label": _ctx.$t('location.country.label')
        }, [
          _createVNode(_component_DKIcon, {
            icon: "globe",
            width: 20
          })
        ], 10, _hoisted_2))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_Megamenu, {
      type: "secondary",
      isTransparent: true,
      isExpanded: _ctx.isExpanded,
      isFull: true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_MegamenuLocationOverview, {
          locationGroups: _ctx.locationGroups,
          contactNavigationTree: _ctx.contactNavigationTree,
          onClickLocationLink: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('clickLocationLink', $event)))
        }, null, 8, ["locationGroups", "contactNavigationTree"])
      ]),
      _: 1
    }, 8, ["isExpanded"]), [
      [_vShow, _ctx.isExpanded]
    ])
  ]))
}